var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#EB2019"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2697_9426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1338 40.041C48.6427 40.041 49.0566 40.4549 49.0566 40.9639V48.9424C49.0565 49.4505 48.6427 49.8643 48.1338 49.8643H36.3213C35.8131 49.8641 35.4006 49.4503 35.4004 48.9424V40.9639C35.4004 40.4552 35.813 40.0411 36.3213 40.041H48.1338ZM36.3682 48.8955H48.0869V41.0098H36.3682V48.8955Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.228 41.752C43.306 41.752 44.1821 42.6281 44.1821 43.7061C44.1821 44.784 43.306 45.6611 42.228 45.6611C41.15 45.6611 40.2739 44.784 40.2739 43.7061C40.2739 42.6281 41.1501 41.752 42.228 41.752ZM42.228 42.7207C41.6847 42.7207 41.2427 43.1628 41.2427 43.7061C41.2427 44.25 41.6848 44.6924 42.228 44.6924C42.772 44.6924 43.2144 44.25 43.2144 43.7061C43.2144 43.1628 42.772 42.7207 42.228 42.7207Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.228 44.7051C42.4954 44.7051 42.7124 44.9221 42.7124 45.1895V47.667C42.7124 47.9351 42.4953 48.1514 42.228 48.1514C41.9606 48.1513 41.7446 47.9348 41.7446 47.667V45.1895C41.7446 44.9224 41.9605 44.7051 42.228 44.7051Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9141 33.9004C46.2217 33.9004 48.0995 35.7774 48.0996 38.085V40.5293L48.0898 40.627C48.0444 40.8477 47.8493 41.0136 47.6152 41.0137H36.8428C36.5756 41.0137 36.3585 40.7973 36.3584 40.5293V38.085C36.3585 35.7774 38.2354 33.9005 40.543 33.9004H43.9141ZM40.543 34.8691C38.7695 34.8692 37.3263 36.3115 37.3262 38.085V40.0449H47.1309V38.085C47.1308 36.3114 45.687 34.8691 43.9141 34.8691H40.543Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8301 36.3379C44.5544 36.338 45.9578 37.7406 45.958 39.4648V40.5234C45.958 40.7914 45.7407 41.0086 45.4736 41.0088H38.9834C38.7162 41.0088 38.499 40.7915 38.499 40.5234V39.4648C38.4993 37.7407 39.9018 36.3381 41.626 36.3379H42.8301ZM41.626 37.3066C40.4358 37.3069 39.468 38.2747 39.4678 39.4648V40.04H44.9893V39.4648C44.989 38.2747 44.0204 37.3068 42.8301 37.3066H41.626Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7422 19.959C42.1151 19.6806 42.6268 19.6802 43 19.958C43.0633 20.0049 50.2941 25.3216 59.4746 25.6396H59.4756C60.0411 25.6607 60.4902 26.125 60.4902 26.6914V42.6035H60.4893C60.5029 43.0142 60.5695 46.7248 58.5088 51.1064C56.5435 55.2862 52.1991 60.8615 42.6787 63.7715H42.6768C42.5787 63.8007 42.4761 63.8173 42.3721 63.8174C42.2679 63.8174 42.1646 63.8008 42.0664 63.7715H42.0645C32.5443 60.8615 28.1996 55.2861 26.2344 51.1064C24.1751 46.7249 24.2403 43.0143 24.2539 42.6035V26.6914C24.2539 26.1251 24.7022 25.6608 25.2676 25.6396H25.2686C29.8637 25.4802 33.9656 24.074 36.9316 22.6973C38.4138 22.0093 39.6102 21.3297 40.4395 20.8193C40.8539 20.5642 41.1768 20.3514 41.3975 20.2012C41.5077 20.1261 41.5924 20.0667 41.6504 20.0254C41.6794 20.0047 41.7024 19.9888 41.7178 19.9775C41.7253 19.972 41.7312 19.9679 41.7354 19.9648C41.7395 19.9618 41.7412 19.96 41.7412 19.96L41.7422 19.959ZM42.3711 22.083C40.4309 23.3847 34.2335 27.1255 26.3564 27.6846V42.6191C26.3564 42.628 26.3559 42.6453 26.3545 42.666C26.3545 42.666 26.355 42.6807 26.3545 42.708C26.354 42.7353 26.3534 42.7756 26.3535 42.8281C26.3538 42.9332 26.3561 43.0876 26.3652 43.2852C26.3836 43.6807 26.4286 44.2501 26.5342 44.9463C26.7455 46.3392 27.2 48.2392 28.1699 50.2812C30.7246 55.6595 35.4894 59.4919 42.3711 61.6631C49.285 59.4827 54.0608 55.6269 56.6064 50.2129C58.524 46.1311 58.3882 42.6804 58.3877 42.666V42.6514C58.3874 42.6464 58.3867 42.6329 58.3867 42.6191V27.6846C50.5074 27.1253 44.3102 23.3842 42.3711 22.083Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2697_9426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(20.5 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.fb654e9892a92aea62e18068fbd51aa3.svg";
export { ForwardRef as ReactComponent };